import React from 'react'
import { findDOMNode } from 'react-dom'
import { TimelineLite, TweenLite } from 'gsap'
import ScrollMagic from 'scrollmagic'

export default {

    initialise (NavDesktop) {
        this.NavDesktopNode = findDOMNode(NavDesktop)
        this.navBg = this.NavDesktopNode.getElementsByClassName('nav-bg')
        this.subNavBgAnimated = this.NavDesktopNode.getElementsByClassName('subnav-bg-animated')
    },

    handleSubNavMouseEnter (event) {
        const el = event.currentTarget
        const subNav = [...el.getElementsByTagName('ul')]
        const tl = new TimelineLite()

        subNav.map(innerEl => {
            TweenLite.set(innerEl, { height: 'auto', display: 'block' })
            tl.from(innerEl, 0.1, { height: 0 })
        })
    },

    handleSubNavMouseLeave (event) {
        const el = event.currentTarget
        const subNav = [...el.getElementsByTagName('ul')]
        const tl = new TimelineLite()

        subNav.map((innerEl) => {
            tl.to(innerEl, 0.25, { height: '0%', ease: Power3.easeOut })
                .set(innerEl, { display: 'none', height: 'auto' })
        })
    },

    // For Tablets
    handleSubNavTouch (event) {
        const el = event.currentTarget
        const subNav = [...el.getElementsByTagName('ul')]
        const tl = new TimelineLite()

        subNav.map(innerEl => {
            TweenLite.set(innerEl, { height: 'auto', display: 'block' })
            tl.from(innerEl, 0.1, { height: 0 })
        })
    },

    closeAllSubNavs () {
        [...document.querySelectorAll('.nav .nav-dropdown')].map(innerEl => {
            const tl = new TimelineLite()
            tl.to(innerEl, 0.25, { height: '0%', ease: Power3.easeOut })
                .set(innerEl, { display: 'none', height: 'auto' })
        })
    },

    animateOnScroll (container) {
    	const controller = new ScrollMagic.Controller()
        const tl = new TimelineLite()

        tl.add(() => {
            container.style.position = 'fixed'
        })
    	tl.fromTo(container, 0.5, { fontSize: '100%' }, { height: '60px', fontSize: '90%', className: '+=animated' })

    	new ScrollMagic.Scene({
            triggerHook: 'onEnter',
            duration: 50
        })
            .setTween(tl)
            .addTo(controller)
    }

}



// WEBPACK FOOTER //
// ./resources/js/layout/NavDesktop/animations.js